import { Box, Checkbox, FormControl, FormErrorMessage } from '@chakra-ui/react';
import { nodeParser } from '@kontent-ai/delivery-node-parser';
import { createRichTextHtmlResolver } from '@kontent-ai/delivery-sdk';
import { Field } from 'formik';
import { CheckboxFormField } from 'models';
import React, { FunctionComponent } from 'react';

import { validatCheckField } from '../../utils/form/validation';

interface CheckboxFieldProps {
  model: CheckboxFormField;
  initialValue: boolean;
}

export const CheckboxField: FunctionComponent<CheckboxFieldProps> = ({ model, initialValue }) => {
  const html = createRichTextHtmlResolver(nodeParser).resolveRichText({
    element: model.elements.formOption.linkedItems[0].elements.label,
  }).html;
  return (
    <Field type='checkbox' name={model.elements.name.value} validate={validatCheckField(model)}>
      {({ field, form }) => (
        <FormControl isInvalid={form.errors[model.elements.name.value] && form.touched[model.elements.name.value]}>
          <Checkbox {...field} defaultChecked={initialValue} value={model.elements.name.value}>
            <Box
              textStyle={'desktop.body.s'}
              sx={{
                a: {
                  textDecor: 'underline',
                },
              }}
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </Checkbox>
          <FormErrorMessage>{form.errors[model.elements.name.value]}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
};
